import axios from "axios"
import { clearAdminSession } from "./adminSession"
import { resolveApiBaseUrl } from "./apiEndpoint"

const service = axios.create({
  baseURL: resolveApiBaseUrl(),
  timeout: 10000
})

service.interceptors.request.use(config => {
  const token = localStorage.getItem("admin_token")
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res && typeof res.code !== "undefined" && res.code !== 0) {
      const error = new Error(res.message || "请求失败")
      error.code = res.code
      if (res.code === 4010) {
        clearAdminSession()
        if (window.location.hash !== "#/login") window.location.hash = "#/login"
      } else if (res.code === 4011 && window.location.hash !== "#/change-password") {
        window.location.hash = "#/change-password"
      }
      return Promise.reject(error)
    }
    return res
  },
  error => {
    if (error.response && error.response.status === 401) {
      clearAdminSession()
      if (window.location.hash !== "#/login") window.location.hash = "#/login"
    }
    return Promise.reject(error)
  }
)

export default service
